//const url = "https://concise-rampart-413810.lm.r.appspot.com";
//const url="http://localhost:5000"
//const url="https://emeric-backend-z573vwoula-lz.a.run.app"

//const url= "https://emeric-backend-finaali-z573vwoula-lz.a.run.app"

const url="https://emeric-back-z573vwoula-uc.a.run.app"
export { url }

